import React, { Children, useContext, useEffect, useState } from 'react';
import { useHistory, withRouter, useParams } from 'react-router-dom';
import '../../App.css';
import compose from 'recompose/compose';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import { styled } from '../../components/styled';
import { Grid, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { ArrowBack, DeleteForever } from '@material-ui/icons';
import SpDialog from '../../components/atoms/SpDialog';
import { theme } from '../../components/theme';
import moment from 'moment';
import { createReservation, findReservationsByStationId } from '../../models/actions/Reservations';
import { findStationById } from '../../models/actions/Stations';
import AgendaCalendarEventCard from '../../pages/stations/shared/AgendaCalendarEventCard';
import { useForm } from 'react-hook-form';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import SpTextInput from '../../components/atoms/SpTextInput';
import { SpSelect, SpSelectMenuItem } from '../../components/atoms/SpSelect';
import { UserSessionContext } from '../../App';

//localization for the calendar
moment.locale('it');
const localizer = momentLocalizer(moment);

const StationReservations = (props) => {
  const [currentReservations, setCurrentReservations] = useState([]);
  const [currentStation, setCurrentStation] = useState();
  const [openAddActivity, setOpenAddActivity] = useState(false);
  const [openDetailActivity, setOpenDetailActivity] = useState(false);
  const [eventDetail, setEventDetail] = useState();
  const [eventsList, setEventsList] = useState([]);
  const [selectedBikes, setSelectedBikes] = useState([]);
  const [defaultView, setDefaultView] = useState('month');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');

  const { authData, setAuthData } = useContext(UserSessionContext);

  const history = useHistory();
  const { stationId } = useParams();

  //React hook form
  const { control, register, handleSubmit, getValues, setValue, reset, errors, watch } = useForm({
    shouldUnregister: false
  });

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const responseReservation = await findReservationsByStationId({ id_station: stationId }, authData.accessToken);
      if (responseReservation) {
        setCurrentReservations(responseReservation);
        updateEventsList(responseReservation);
      }
      const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
      responseStation && setCurrentStation(responseStation);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const handleSelectBikes = (event) => {
    setSelectedBikes(event.target.value);
  };

  const MyCustomHeader = ({ label }) => (
    <div style={{ width: '100%', backgroundColor: 'rgb(77, 172, 39,0.7)', color: theme.colors.mainGreen.main }}>
      <div style={{ color: theme.colors.mainGreen.main, border: `1px solid ${theme.colors.mainGreen.main}` }}>{label}</div>
    </div>
  );

  const handleNewEventSelected = (event) => {
    setOpenAddActivity(true);
    setOpenDetailActivity(false);
    setValue('start_date', moment(event.start).format('YYYY-MM-DD'));
  };

  const handleEventDetailSelected = (event) => {
    setEventDetail(event);
    setOpenDetailActivity(true);
  };

  const updateEventsList = (eventsListData) => {
    let newEventsList = [];
    eventsListData.map((event, eventIdx) => {
      newEventsList.push({
        id: event.id,
        user: event?.user,
        start: new Date(event.start_date),
        end: new Date(event.start_date),
        start_time: event.start_time,
        end_time: event.end_time,
        station: event.station,
        bikes: event.bikes,
        rent: event.rent
      });
    });
    console.log('FOrMATTED ARR', newEventsList);
    setEventsList(newEventsList);
  };

  const ColoredEventCell = ({ event }) => {
    console.log(event);
    return (
      <div style={{ display: 'flex', flex: 1, maxHeight: 60 }}>
        <div
          className="rbc-event-label"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', marginLeft: 5 }}>
            <SpText variant={'h4ComponentLabelCardTitle'}>{`Stazione: ${event?.station?.name}`}</SpText>
            <SpText variant={'h6ComponentLabelCardSubtitle'}>{`Proprietario:  ${event.station?.user?.first_name ? event.station?.user?.first_name.toString() + ' ' + event.station?.user?.second_name?.toString() : event.station?.user?.name.toString()}  `}</SpText>
          </div>
        </div>
      </div>
    );
  };

  //rendering custom card
  const AgendaEventWrapper = (props) => {
    return React.cloneElement(Children.only(props.children), {
      style: {
        ...props.children.props.style,
        width: '96%',
        backgroundColor: theme.colors.mainGreen.thirdGreen,
        padding: `8px`,
        color: `${theme.colors.mainGreen.main} !important`,
        height: '45px'
      }
    });
  };

  const CustomToolbar = (toolbar) => {
    const goToBack = () => {
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
      toolbar.onNavigate('prev');
    };

    const goToNext = () => {
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
      toolbar.onNavigate('next');
    };

    const goToCurrent = () => {
      const now = new Date();
      toolbar.date.setMonth(now.getMonth());
      toolbar.date.setYear(now.getFullYear());
      toolbar.onNavigate('current');
    };

    const goMonth = () => {
      setDefaultView('month');
    };

    const goWeek = () => {
      setDefaultView('week');
    };

    const goDays = () => {
      setDefaultView('day');
    };
    const goAgenda = () => {
      setDefaultView('agenda');
    };

    const label = () => {
      const date = moment(toolbar.date);
      return (
        <SpText variant="monthYearCalendar">
          <b>{date.format('MMMM')}</b>
          <span> {date.format('YYYY')}</span>
        </SpText>
      );
    };

    return (
      <div
        container
        className="rbc-toolbar"
        spacing={1}
        style={{ marginBottom: '1%', justifyContent: 'space-evenly' }}
      >
        <div className="rbc-button-group">
          <button
            style={{ color: theme.colors.mainGreen.main, border: `1px solid ${theme.colors.mainGreen.main}` }}
            onClick={() => setDefaultView('month')}
          >
            Mesi
          </button>
          <button
            style={{ color: theme.colors.mainGreen.main, border: `1px solid ${theme.colors.mainGreen.main}` }}
            onClick={() => setDefaultView('week')}
          >
            Settimane
          </button>
          <button
            style={{ color: theme.colors.mainGreen.main, border: `1px solid ${theme.colors.mainGreen.main}` }}
            onClick={() => setDefaultView('days')}
          >
            Giorni
          </button>
          <button
            style={{ color: theme.colors.mainGreen.main, border: `1px solid ${theme.colors.mainGreen.main}` }}
            onClick={() => setDefaultView('agenda')}
          >
            Agenda
          </button>
        </div>
        <label
          style={{ justifyContent: 'center' }}
          className={'label-date'}
        >
          {label()}
        </label>
        <div className="back-next-buttons">
          <button
            style={{ backgroundColor: 'rgb(77, 172, 39,0.7)', color: theme.colors.mainGreen.main, fontWeight: 600, border: `1px solid ${theme.colors.mainGreen.main}` }}
            className="btn-back"
            onClick={goToBack}
          >
            Precendente
          </button>
          <button
            style={{ backgroundColor: 'rgb(77, 172, 39,0.7)', color: theme.colors.mainGreen.main, fontWeight: 600, border: `1px solid ${theme.colors.mainGreen.main}` }}
            className="btn-current"
            onClick={goToCurrent}
          >
            Oggi
          </button>
          <button
            style={{ backgroundColor: 'rgb(77, 172, 39,0.7)', color: theme.colors.mainGreen.main, fontWeight: 600, border: `1px solid ${theme.colors.mainGreen.main}` }}
            className="btn-next"
            onClick={goToNext}
          >
            Successivo
          </button>
        </div>
      </div>
    );
  };

  const createNewReservation = async (data) => {
    try {
      if (selectedBikes.length == 0) {
        setError('Seleziona almeno una ebike!');
        return;
      } else {
        setError(null);
        const createdReservation = await createReservation(
          {
            bikes: selectedBikes,
            start_time: data.start_time
          },
          authData.accessToken
        );
        if (!createdReservation.error) {
          props.snackbarShowMessage(createdReservation.message);
          fetchData();
          setOpenAddActivity(false);
          setSelectedBikes([]);
          setValue('start_time');
        } else {
          props.snackbarShowErrorMessage(createdReservation.error);
        }
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  moment.locale('it');
  momentLocalizer(moment);

  useEffect(() => {
    fetchData();
  }, []);

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  });

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/ebikes`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%', backgroundColor: theme.colors.mainGreen.secondary, color: 'white' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reports`)}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push(`/stations/edit/${stationId}`)}
                style={{ width: 25, color: theme.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {`Home / Stazione / ${currentStation?.name} / Prenotazioni`}
              </SpText>
            </TitleToolbarSection>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ backgroundColor: 'rgb(77, 172, 39,0.3)', padding: 5 }}
          >
            <Calendar
              selectable
              events={eventsList}
              scrollToTime={new Date()}
              defaultDate={new Date()}
              view={'month'}
              onDragStart={() => console.log('Drag started')}
              onSelectEvent={handleEventDetailSelected}
              onSelectSlot={console.info('select') /* handleNewEventSelected */}
              step={60}
              eventPropGetter={(event, start, end, isSelected) => {
                const backgroundColor = event.color;
                const style = {
                  backgroundColor: backgroundColor,
                  borderRadius: '5px',
                  opacity: 1,
                  paddingTop: '2px',
                  paddingBottom: '2px',
                  border: '0px',
                  display: 'block'
                };
                return {
                  style: style
                };
              }}
              messages={{
                showMore: (total) => (
                  <div
                    style={{ cursor: 'pointer', color: theme.colors.mainGreen.main }}
                    onMouseOver={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                  >
                    {`+${total} mostra ancora`}
                  </div>
                )
              }}
              components={{
                toolbar: CustomToolbar,
                day: { header: MyCustomHeader },
                week: { header: MyCustomHeader },
                month: { header: MyCustomHeader },
                event: ColoredEventCell,
                eventWrapper: AgendaEventWrapper
              }}
              localizer={localizer}
            />
          </Grid>

          {/* {stationId ? (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Modifica"} style={{ width: "100%" }} variant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					) : (
						<Grid item xs={3}>
							<SpButton buttonType='accept' text={"Salva"} style={{ width: "100%" }} ariant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					)} */}
        </Grid>
      </Grid>
      {eventDetail && (
        <SpDialog
          variant="bigDialog"
          open={openDetailActivity}
          setOpen={setOpenDetailActivity}
          title={'Prenotazione'}
        >
          <AgendaCalendarEventCard
            event={eventDetail}
            fetchData={fetchData}
            setOpenDetailActivity={setOpenDetailActivity}
            openDetailActivity={openDetailActivity}
          />
        </SpDialog>
      )}
      <SpDialog
        variant="bigDialog"
        open={openAddActivity}
        setOpen={setOpenAddActivity}
        title={'Aggiungi una prenotazione'}
      >
        <form onSubmit={handleSubmit(createNewReservation)}>
          <Grid
            container
            direction="column"
            spacing={2}
          >
            <Grid
              item
              xs={12}
              container
              style={{ justifyContent: 'flex-start', alignItems: 'center' }}
            >
              <SpSelect
                label={'Scegli i parametri di carico da aggiungere'}
                multiple
                formControlWidth={'100%'}
                value={selectedBikes}
                onChange={handleSelectBikes}
              >
                {currentStation?.bikes.map((b) => {
                  return (
                    <SpSelectMenuItem
                      key={b.id}
                      value={b.id}
                    >
                      {b.code}
                    </SpSelectMenuItem>
                  );
                })}
              </SpSelect>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SpTextInput
                type="time"
                name="start_time"
                min="05:00"
                max="22:00"
                inputRef={register({ required: true })}
                label={'Orario di inizio'}
              />
              {error && <SpText variant="h4ComponentLabelError">{error}</SpText>}
            </Grid>
            <SpButton
              buttonType={'accept'}
              variant="none"
              text={'Aggiungi prenotazione'}
              style={{ marginTop: '4%' }}
              type="submit"
            />
            <Grid
              item
              xs={12}
            ></Grid>
          </Grid>
        </form>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(StationReservations);
